import { Component, inject } from '@angular/core';
import { SubEnvironmentService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SubEnvironmentCreateDto,
  SubEnvironmentDto,
  SubEnvironmentExcelDownloadDto,
  SubEnvironmentUpdateDto,
} from '../proxy/planning/dtos/sub-environment';
import { SUBENVIRONMENT_CONFIG, SUBENVIRONMENT_FIELDS } from './sub-environment.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sub-environment',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SubEnvironmentService, ConfirmationService],
  templateUrl: './sub-environment.html',
  styleUrl: './sub-environment.scss',
})
export class SubEnvironment extends BaseCrudComponent<
  SubEnvironmentDto,
  SubEnvironmentCreateDto,
  SubEnvironmentUpdateDto,
  SubEnvironmentExcelDownloadDto
> {
  service = inject(SubEnvironmentService);
  config = SUBENVIRONMENT_CONFIG;
  fields = SUBENVIRONMENT_FIELDS;

  protected prepareUpdateDto(data: any, selected: SubEnvironmentDto): SubEnvironmentUpdateDto {
    return {
      name: data.name,
      code: data.code,
      landCoverId: data.landCoverId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SubEnvironment';
  }
}
